export default [
  {
    path: '/orders/all',
    name: 'all-orders',
    component: () => import('@/views/orders/AllOrders.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Tous les colis',
      breadcrumb: [
        {
          text: 'Colis',
          to: { name: 'all-orders' },
        },
        {
          text: 'Tous les colis',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'supplier', 'sales', 'customer_support', 'accountant'],
    },
  },
  {
    path: '/orders/echange',
    name: 'echange-order',
    props: true,
    component: () => import('@/views/orders/Echange.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Échange de colis',
      breadcrumb: [
        {
          text: 'Colis',
          to: { name: 'orders-index' },
        },
        {
          text: 'Échange de colis',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'supplier', 'sales'],
    },
  },
  {
    admin: true,
    path: '/orders/quick-edit',
    name: 'orders-quick-edit',
    props: true,
    component: () => import('@/views/orders/QuickUpdate.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Modification rapide du statut',
      breadcrumb: [
        {
          text: 'Colis',
          to: { name: 'orders-index' },
        },
        {
          text: 'Modification rapide',
          active: true,
        },
      ],
      roles: ['admin', 'manager', 'warehouse_operator'],
    },
  },
  {
    path: '/orders/historique',
    name: 'order-hist',
    props: true,
    component: () => import('@/views/orders/Historique.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Historique logistique des colis',
      breadcrumb: [
        {
          text: 'Colis',
          to: { name: 'orders-index' },
        },
        {
          text: 'Historique logistique',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'supplier', 'sales'],
    },
  },
  {
    path: '/orders/status',
    name: 'order-status',
    props: true,
    component: () => import('@/views/orders/Status.vue'),
    meta: {
      layout: 'vertical',
      requireLogin: true,
      pageTitle: 'Colis',
      breadcrumb: [
        {
          text: 'Réception central',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
  {
    path: '/orders/desynchronize',
    name: 'order-desynchronize-scan',
    component: () => import('@/views/orders/DesynchronizeScan.vue'),
    meta: {
      layout: 'vertical',
      requireLogin: true,
      pageTitle: 'Désynchronisation par scan',
      breadcrumb: [
        {
          text: 'Colis',
          to: { name: 'orders-index' },
        },
        {
          text: 'Désynchronisation',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/orders/quick-create',
    name: 'order-quick-add',
    props: true,
    component: () => import('@/views/orders/QuickCreate.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Création rapide de colis',
      breadcrumb: [
        {
          text: 'Colis',
          to: { name: 'orders-index' },
        },
        {
          text: 'Création rapide',
          active: true,
        },
      ],
      roles: ['supplier'],
    },
  },
  {
    path: '/orders/create',
    name: 'order-add',
    props: true,
    component: () => import('@/views/orders/Create.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Créer un nouveau colis',
      breadcrumb: [
        {
          text: 'Colis',
          to: { name: 'orders-index' },
        },
        {
          text: 'Création de colis',
          active: true,
        },
      ],
      roles: ['supplier'],
    },
  },
  {
    path: '/orders/support-tracking',
    name: 'support-order-tracking',
    component: () => import('@/views/orders/SupportTracking.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Suivi des commandes',
      breadcrumb: [
        {
          text: 'Colis',
          active: true,
        },
        {
          text: 'Suivi des commandes',
          active: true,
        },
      ],
      roles: ['customer_support', 'admin', 'superadmin'],
    },
  },
  {
    path: '/orders',
    name: 'orders-index',
    component: () => import('@/views/orders/Index.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Liste des colis',
      breadcrumb: [
        {
          text: 'Colis',
          to: { name: 'orders-index' },
        },
        {
          text: 'Liste des Colis',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'supplier', 'sales', 'customer_support', 'accountant'],
    },
  },
  {
    path: '/orders/:level',
    name: 'order-list',
    props: route => ({ level: Number(route.params.level) }),
    component: () => import('@/views/orders/Index.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Liste des colis',
      breadcrumb: [
        {
          text: 'Colis',
          to: { name: 'orders-index' },
        },
        {
          text: 'Liste des Colis',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'supplier', 'sales', 'customer_support', 'accountant'],
    },
  },
  {
    path: '/orders/edit/:id',
    name: 'order-edit',
    props: true,
    component: () => import('@/views/orders/Edit.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Modifier un colis',
      breadcrumb: [
        {
          text: 'Colis',
          to: { name: 'order-list', params: { level: 0 } },
        },
        {
          text: 'Modification de colis',
          active: true,
        },
      ],
      roles: ['admin', 'manager', 'supplier'],
    },
  },
  {
    path: '/orders/show/:id',
    name: 'order-show',
    props: true,
    component: () => import('@/views/orders/Show.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Détails du colis',
      breadcrumb: [
        {
          text: 'Colis',
          to: { name: 'all-orders' },
        },
        {
          text: 'Liste des colis',
          to: { name: 'order-list', params: { level: 0 } },
        },
        {
          text: 'Détails du colis',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'supplier', 'sales', 'customer_support'],
    },
  },
  {
    path: '/orders/echange/:id',
    name: 'order-echange-show',
    props: true,
    component: () => import('@/views/orders/ShowEchange.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Détails de l\'échange de colis',
      breadcrumb: [
        {
          text: 'Colis',
          to: { name: 'orders-index' },
        },
        {
          text: 'Échange de colis',
          to: { name: 'orders-echange' },
        },
        {
          text: 'Détails de l\'échange',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
  {
    path: '/orders/echange/bulk-print',
    name: 'order-echange-bulk-show',
    component: () => import('@/views/orders/BulkShowEchange.vue'),
    meta: {
      requireLogin: true,
      breadcrumb: [
        {
          text: 'Colis',
          to: { name: 'orders-index' },
        },
        {
          text: 'Échange de colis',
          to: { name: 'orders-echange' },
        },
        {
          text: 'Impression groupée',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
  // {
  //   path: '/orders/pickup/scan',
  //   name: 'scan-order',
  //   props: true,
  //   component: () => import('@/views/orders/Pickup.vue'),
  //   meta: {
  //     requireLogin: true,
  //     pageTitle: 'Pickup colis',
  //     roles: ['delivery_man'],
  //   },
  // },
]
